export default __webpack_public_path__ + "static/media/09.22e4ae24.jpg";